module.exports = __webpack_public_path__ + "static/media/DSC_0042.8a15a3e5.jpg";